import HTTPService from "../../../App/HTTPService"
import StorageService from "../../../App/StorageService"
import { getSignupStatus, setEmailError } from "./SignupSlice"
import { StorageKey } from "../../../App/enums"

export const dropdownGetRequest = () => {
    return HTTPService.get("/referral/")
}

export const countryStateGetRequest = (query: string) => {
    return HTTPService.get("/address-api/search/?query=" + query)
}

export const StateGetRequest = (id : number) => {
    return HTTPService.get("/state/" + id + "/")
}

export const orgCategoriesGetRequest = () => {
    return HTTPService.get("/organization-categories")
}

export const emailGetRequest =
    (userForm: { name: string; lastName: string; email: string; password: string; confirmPassword: string, location: string, involved_organisation_category_id: number }, previewRoomJoinId?: string) => async (dispatch: Function) => {
        HTTPService.get(`/users/?email=${userForm.email}`, {
            email: userForm.email,
        }).then(async response => {
            if (response.data.length > 0) {
                await dispatch(setEmailError())
            } else {
                const signupForm = {
                    name: userForm.name,
                    lastName: userForm.lastName,
                    email: userForm.email,
                    password: userForm.password,
                    confirmPassword: userForm.confirmPassword,
                    location: userForm.location,
                    involved_organisation_category_id: userForm.involved_organisation_category_id,
                    // id: id,
                    privacy_settings: [
                        {
                            private_messages: true,
                            search_results: true,
                            show_location: true,
                            show_contact_info: true,
                        },
                    ],
                    // Reuse backend invitation field for preview auto-join
                    ...(previewRoomJoinId && { room_invitation_id: previewRoomJoinId }),
                }

                StorageService.setItem(StorageKey.signupForm, JSON.stringify(signupForm))
                await dispatch(getSignupStatus({ status: true }))
            }
        })
    }
